import type { StringTable } from '../types'

// zh-TW (Traditional Chinese, Taiwan usage, P2 primary per promotion-v2).
// Fully converted from the zh (Simplified) base to Traditional Chinese —
// Taiwan vocabulary where it matters (影片 not 視頻, 設定 not 设置, 搜尋 not
// 搜索, 相簿 not 相册, 檔案/文件 not 文档, 儲存/儲值 not 保存/充值, 軟體 not
// 软件). getStrings prefers this table for zh-TW/zh-HK/zh-Hant browsers.

export const zhTW: StringTable = {
  'common.playbackSpeed': '播放速度',
  // Navigation
  'nav.review': '複習',
  'nav.library': '詞庫',
  'nav.stats': '統計',
  'nav.settings': '設定',
  'nav.appTitleSuffix': '詞彙閃卡',
  'nav.openMenu': '開啟選單',
  'nav.closeMenu': '關閉選單',
  'nav.mainNav': '主導覽',
  'nav.reviewSession': '複習階段',
  'nav.cardLibrary': '卡片詞庫',
  'nav.media': '影片',
  'nav.statistics': '統計資料',
  'nav.create.label': '建立',
  'nav.create.text': '文字',
  'nav.create.doc': '文件',
  'nav.create.media': '影片 / 音訊',

  // Generate view
  'generate.takePhoto': '拍照',
  'generate.changePhoto': '更換照片',
  'generate.chooseGallery': '相簿',
  'generate.clearText': '清除文字',
  'generate.button': '生成卡片',
  'generate.buttonPhoto': '從照片生成',
  'generate.buttonText': '從文字生成',
  'generate.buttonBoth': '從照片+文字生成',
  'generate.buttonLoading': '生成中...',
  'generate.minInput': '新增照片或文字以開始',
  'generate.convertingHeic': '轉換 HEIC...',
  'generate.compressing': '壓縮中...',
  'generate.retry': '重試',
  'generate.removeImage': '移除圖片',
  'generate.cardTextInput': '卡片文字輸入',
  'generate.preview': '預覽',

  // Generate errors
  'generate.error.invalidImage': '請上傳圖片（JPEG、PNG、GIF、WebP 或 HEIC）',
  'generate.error.imageTooLarge': '圖片不能超過 {{maxSize}}',
  'generate.error.compressionFailed': '壓縮後圖片仍然過大,請改用較小的照片',
  'generate.error.heicFailed': '圖片處理失敗',
  'generate.error.generateFailed': '生成卡片失敗',

  // Generate — daily cap / upgrade
  'generate.cap.body': '餘額不足（{{balance}} 能量）。儲值後繼續生成。',
  'generate.cap.upgrade': '儲值',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': '能量餘額：{{balance}}',
  'generate.energyBadge.zero': '能量已用完',
  'generate.firstCard.body': '你有 {{balance}} 點能量 — 足夠生成第一批卡片。在下方輸入一個單字試試 →',
  'generate.firstCard.dismiss': '關閉',
  'generate.sampleWords.label': '試試這些詞：',
  'generate.aiImageToggle': 'AI 配圖',
  'generate.aiImageHint': '為保留的卡片加上 AI 配圖（每張 {{cost}} 能量）',
  'generate.aiImageAutoSkip': '部分 AI 配圖未能生成 — 點擊每張卡片上的圖片按鈕重試。',

  // Library view
  'library.loading': '載入詞庫...',
  'library.retry': '重試',
  'library.noCards': '還沒有卡片！',
  'library.noCardsHint': '生成一些閃卡來建立你的詞庫',
  'library.emptyExtensionHint': '小提示:在 YouTube 看影片時選取任一單字,用 Piccard 擴充功能一鍵儲存。', 'library.emptyCta': '建立第一張卡',
  'library.dismiss': '關閉',
  'library.deleteTitle': '刪除卡片？',
  'library.deleteConfirm': '此操作無法復原,確定要刪除嗎？',
  'library.cancel': '取消',
  'library.deleting': '刪除中...',
  'library.delete': '刪除',
  'library.filterAll': '全部',
  'library.filterLearning': '學習中',
  'library.filterMastered': '已掌握',
  'library.card_one': '{{count}} 張卡片',
  'library.card_other': '{{count}} 張卡片',
  'library.match_one': '{{count}} 個符合',
  'library.match_other': '{{count}} 個符合',
  'library.noCardsMatch': '沒有卡片符合「{{query}}」',
  'library.prevPage': '上一頁',
  'library.nextPage': '下一頁',
  'library.searchImagesFor': '搜尋 {{word}} 的圖片',
  'library.unmaster': '取消掌握 {{word}}',
  'library.markMastered': '將 {{word}} 標記為已掌握',
  'library.searchPlaceholder': '搜尋{{filter}}卡片...',
  'library.drag': '拖曳',
  'library.swipeHint': '← 刪除 · 查看 →',
  'library.back': '背面',
  'library.images': '圖片',
  'library.master': '掌握',
  'library.mastered': '已掌握',
  'library.view': '查看',
  'library.fromMedia': '來自媒體',
  'library.fromDoc': '來自文件',

  // Review view
  'review.ready': '準備複習了嗎？',
  'review.readyHint': '選擇一個主題,或開始複習所有到期卡片',
  'review.recognition': '辨識',
  'review.production': '產出',
  'review.topics': '主題',
  'review.domains': '領域',
  'review.startReview': '開始複習',
  'review.loading': '載入卡片...',
  'review.retry': '重試',
  'review.tapFlip': '點擊翻面',
  'review.answer': '答案',
  'review.newWord': '新單字',
  'review.cardProgress': '第 {{current}} 張,共 {{total}} 張',
  'review.searchImagesFor': '搜尋 {{word}} 的圖片',
  'review.allCaughtUp': '全部複習完了！',
  'review.nothingToReview': '暫時沒有需要複習的內容',
  'review.makeSomeCards': '建立一些卡片',
  'review.makeMoreCards': '建立更多「{{topic}}」卡片',
  'review.backToReview': '返回複習',
  'review.noMatchTitle': '沒有卡片符合「{{topic}}」',
  'review.noMatchHint': '包含部分符合你主題的卡片',
  'review.fallbackTitle': '沒有卡片符合「{{topic}}」——以下是所有到期卡片',
  'review.sessionComplete': '複習完成！',
  'review.cardsReviewed': '已複習卡片',
  'review.again': '再來',
  'review.hard': '困難',
  'review.good': '良好',
  'review.easy': '簡單',
  'review.timeSpent': '用時',
  'review.cardReviewed_one': '今天複習了 {{count}} 張卡片',
  'review.cardReviewed_other': '今天複習了 {{count}} 張卡片',
  'review.startNewSession': '開始新一輪複習',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': '分享今日打卡卡片',
  'share.title': '分享學習成果',
  'share.name': '顯示名稱',
  'share.create': '生成分享連結',
  'share.copied': '連結已複製！',
  'share.open': '開啟分享頁',
  'share.saveImage': '儲存打卡圖片',
  'share.myLinks': '我的分享連結',
  'share.revoke': '撤銷',
  'share.empty': '還沒有分享連結——完成一次複習就能分享你的連續打卡。',
  'review.tapOrSpace': '點擊卡片或按空白鍵翻面',
  'review.images': '圖片',
  'review.prefillMore': '更多關於{{topic}}的詞彙與表達',
  'review.endSession': '結束練習',
  'review.error.loadFailed': '載入卡片失敗',
  'review.error.submitFailed': '提交複習結果失敗',

  // Stats view
  'stats.today': '今天',
  'stats.reviewedToday': '今日已複習',
  'stats.review_one': '次複習',
  'stats.review_other': '次複習',
  'stats.mastered': '已掌握',
  'stats.learned': '已學會',
  'stats.word_one': '個單字',
  'stats.word_other': '個單字',
  'stats.error': '統計資料載入失敗',
  'stats.dailyGoal': '每日目標',
  'stats.goalFresh': '新的開始。',
  'stats.goalGoing': '繼續加油。',
  'stats.goalMet': '達成目標,做得漂亮。',
  'stats.goalHint': '輕觸設定節奏',

  // Settings view
  'settings.title': '設定',
  'settings.languagePair': '語言組合',
  'settings.learn': '學習',
  'settings.pairOption': '{{native}} → 學習 {{target}}',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': '每輪卡片數',
  'settings.cardLabel': '{{count}} 張卡片',
  'settings.changeWarning': '變更語言將重新載入應用程式',
  'settings.apply': '套用',
  'settings.cancelChange': '取消',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': '學習目標',
  'settings.learningContext.optional': '選填',
  'settings.learningContext.placeholder': '例如：GRE 詞彙、HSK 準備、商務英語…',
  'settings.learningContext.hint': '影響 AI 選詞方向,留空則使用預設。',
  'settings.learningContext.try': '試試：',
  'settings.learningContext.example1': 'HSK 準備',
  'settings.learningContext.example2': '商務英語',
  'settings.learningContext.example3': '日常對話',
  'settings.learningContext.example4': '澳洲口語',

  // Settings — subscription
  'settings.plan.balanceTitle': '能量餘額',
  'settings.plan.balanceDesc': '可用 {{balance}} 能量',
  'settings.plan.topup': '儲值 ${{amount}}',
  'settings.plan.energyUnit': '{{energy}} 能量',
  'settings.plan.bonusPct': '+{{percent}}% 獎勵',
  'settings.plan.bestValue': '最划算',
  'settings.support.title': '需要協助？',
  'settings.support.desc': '有問題、帳單或意見回饋 — 歡迎隨時來信。',
  'settings.referral.title': '邀請好友,雙方各得 150 能量',
  'settings.referral.desc': '分享你的連結。好友儲值後,你和朋友各得 150 能量免費。',
  'settings.referral.yourCode': '你的邀請碼',
  'settings.referral.copyCode': '複製邀請碼',
  'settings.referral.tapToCopy': '點按複製',
  'settings.referral.codeCopied': '已複製',
  'settings.referral.shareLink': '分享連結',
  'settings.referral.invited_one': '邀請了 {{count}} 位好友',
  'settings.referral.invited_other': '邀請了 {{count}} 位好友',
  'settings.referral.toppedUp_one': '{{count}} 位已儲值',
  'settings.referral.toppedUp_other': '{{count}} 位已儲值',
  'settings.referral.pendingHint': '等待對方首次儲值 — 提醒一下！',
  'settings.referral.shareText': '用生活照片記單字。你儲值後我們各得 150 能量 — 一起來試 Piccard：',
  'settings.referral.rewardBanner': '你的好友已儲值 — 帳戶已加 150 能量。',
  'settings.referral.rewardDismiss': '知道了',
  'settings.referral.haveCode': '有邀請碼？',
  'settings.referral.codePlaceholder': '輸入邀請碼',
  'settings.referral.codeApply': '套用',
  'settings.referral.codeApplying': '套用中…',
  'settings.referral.codeApplied': '邀請碼已套用 — 你儲值後,你和邀請者各得 150 能量。',
  'settings.referral.codeAlready': '你的帳號已綁定邀請關係。',
  'settings.referral.codeInvalid': '邀請碼無效。',
  'settings.referral.codeSelf': '這是你自己的邀請碼。',

  // Payment (shared)
  'payment.checkoutFailed': '無法開始結帳。請重試。',
  'payment.checkoutLoading': '正在前往結帳…',
  'payment.checkoutSuccess': '儲值成功 — 謝謝！',
  'payment.checkoutCancelled': '已取消付款。',

  // Hamburger menu
  'menu.notSignedIn': '未登入',
  'menu.signOut': '登出',
  'menu.languageLearner': '語言學習者',

  // Onboarding
  'onboarding.iSpeak': '我說…',
  'onboarding.imLearning': '我想學…',
  'onboarding.startLearning': '開始學習',
  'onboarding.changeAnytime': '隨時可以變更',
  'onboarding.back': '← 返回',
  'onboarding.learningContext.label': '有特定的學習目標嗎？',
  'onboarding.learningContext.placeholder': '例如：GRE、HSK、商務英語…（選填）',

  // Auth
  'auth.signInPrompt': '登入以將詞彙儲存到雲端',
  'auth.continueWithGoogle': '使用 Google 登入',
  'auth.continueWithKakao': '透過 Kakao 繼續',
  'auth.signingIn': '登入中...',
  'auth.signingYouIn': '正在為你登入...',
  'auth.signInFailed': '登入失敗',
  'auth.signInError': '登入過程中發生了問題',
  'auth.tryAgain': '重試',
  'auth.loading': '載入中...',

  // Error boundary
  'error.title': '出了點問題',
  'error.description': '發生未預期的錯誤',
  'error.tryAgain': '重試',
  'error.report': '回報',

  // Offline
  'offline.title': '你已離線',
  'offline.description': '部分功能可能受限,請檢查網路連線',
  'offline.notification': '離線通知',
  'offline.retryConnection': '重新連線',

  // PWA install
  'pwa.installPrompt': '安裝 Piccard 以離線使用',
  'pwa.install': '安裝',
  'pwa.dismiss': '關閉',
  'pwa.installAppPrompt': '安裝應用程式提示',
  'pwa.installApp': '安裝應用程式',

  // Card stack
  'cardStack.cardGenerated': '生成了 1 張卡片',
  'cardStack.cardGenerated_other': '生成了 {{count}} 張卡片',
  'cardStack.counter': '{{current}} / {{total}} 張卡片',
  'cardStack.done': '完成',
  'cardStack.reviewNow': '立即複習',
  'cardStack.generateMore': '繼續生成',
  'cardStack.allReviewed': '所有卡片已查看',
  'cardStack.cardsSaved': '{{count}} 張卡片已儲存',
  'cardStack.previousCard': '上一張卡片',
  'cardStack.nextCard': '下一張卡片',
  'cardStack.goToCard': '跳到第 {{n}} 張',

  // Preview card
  'previewCard.generatedCard': '生成的卡片',
  'previewCard.translation': '翻譯',
  'previewCard.definition': '釋義',
  'previewCard.example': '例句',
  'previewCard.searchImagesFor': '搜尋 {{word}} 的圖片',

  // Rating buttons
  'rating.again': '再來',
  'rating.hard': '困難',
  'rating.good': '良好',
  'rating.easy': '簡單',
  'rating.master': '掌握',
  'rating.rateAs': '評為 {{label}}',
  'rating.markMastered': '標記為已掌握',
  'review.stuckHint': "這張卡滑走了 {{count}} 次 — 不是你的問題,有些卡就是記不住。在下面讓它退役,或繼續刷。",

  // Study card
  'studyCard.studyCardFor': '{{word}} 的學習卡片',
  'studyCard.playUsPronunciation': '播放美式發音',
  'studyCard.playUkPronunciation': '播放英式發音',
  'studyCard.searchImagesFor': '搜尋 {{word}} 的圖片',

  // Pronunciation button + badge
  'pronunciation.play': '播放 {{accent}} 發音',

  // Search bar
  'search.clearSearch': '清除搜尋',

  // Tag cloud
  'tagCloud.yourTopics': '你的主題',
  'tagCloud.showMore': '顯示更多 {{count}} 個{{label}}',

  // Queue item
  'queueItem.remove': '移除 {{word}}',

  // Error card
  'errorCard.defaultRetry': '重試',

  // Empty state
  'emptyState.noCards': '還沒有卡片',
  'emptyState.noCardsHint': '建立你的第一張閃卡開始學習',
  'emptyState.createCard': '建立卡片',
  'emptyState.noMastered': '還沒有已掌握的單字',
  'emptyState.noMasteredHint': '將卡片標記為已掌握即可在這裡查看',
  'emptyState.allMastered': '所有卡片都已掌握！',
  'emptyState.greatJob': '做得好！',

  // Progress bar
  'progressBar.cardsLearned': '已學卡片',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'AI 圖片',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': '為「{{word}}」生成 AI 圖片',
  'common.generating': '生成中…',
  'common.imageFailed': '失敗 · 未消耗能量',
  'common.lowEnergy': '能量不足',
  'common.regenerateCard': '重新生成',
  'common.regenerateCardAria': '完全重新生成 {{word}}',

  // Image preview / lightbox
  'imagePreview.enlarge': '放大圖片',
  'imagePreview.close': '關閉',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': '匯入文件',
  'importView.subtitle': '把 PDF 或文字變成單字卡。',
  'importView.chooseFile': '選擇 PDF 或文字檔',
  'importView.pasteLabel': '或貼上文字',
  'importView.pastePlaceholder': '貼上文章、筆記或任何文字…',
  'importView.findVocab': '尋找詞彙',
  'importView.proposing': '正在尋找詞彙…',
  'importView.proposingWait': '正在挑詞並撰寫釋義——長文字通常需要 10–20 秒。',
  'importView.phaseReading': '正在通讀文字…',
  'importView.foundSoFar': '已找到 {{n}} 個 · 還在找…',
  'importView.cancel': '取消',
  'importView.partialBanner': '已找到 {{n}} 個詞,但分析中途中斷了。',
  'importView.retryRest': '補齊剩餘',
  'importView.parsing': '正在讀取文件…',
  'importView.candidates': '{{count}} 個候選詞',
  'importView.keepN': '保留 {{count}} · {{energy}} 能量',
  'importView.generate': '生成 {{count}} 張卡片',
  'importView.selectAll': '全選',
  'importView.clearAll': '清空',
  'importView.priorityHigh': '高價值',
  'importView.highCount': '高價值 {{high}} / 共 {{total}}',
  'mediaView.selectRecommended': '選擇推薦',
  'importView.success': '已新增 {{count}} 張卡片到詞庫',
  'importView.pairMismatch': '卡片將存為 {{pair}} — 目前應用程式設定為 {{current}}。複習前需在設定中切換。',
  'importView.savedAs': '已按 {{pair}} 儲存',
  'importView.reviewInPair': '切換到 {{pair}} 並複習',
  'importView.reviewNow': '立即複習',
  'importView.errorTooLarge': '文件太大(最多約 80 萬字元)。',
  'importView.errorScanned': '沒有可選取的文字——這看起來是掃描版 PDF。',
  'importView.errorRead': '無法讀取該檔案。',
  'importView.errorPropose': '無法提取詞彙,請重試。',
  'importView.errorRateLimited': '操作太頻繁了,等一分鐘再試。',
  'importView.errorLowEnergy': '能量不足,無法儲存這些卡片。',
  'importView.empty': '未找到詞彙,試試其他文件。',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': '儲存到 Piccard',
  'quickSave.subtitle': '一鍵生成,馬上就能複習。',
  'quickSave.generate': '生成卡片',
  'quickSave.generateCost': '生成卡片 · {{energy}} 能量',
  'quickSave.generating': '正在製作卡片…',
  'quickSave.slowWait': '製作卡片通常需要幾秒鐘——稍待片刻。',
  'quickSave.pairSourceExtension': '來自這部影片',
  'quickSave.pairSourceSettings': '你的應用程式設定',
  'quickSave.pairSourceBrowser': '你的瀏覽器語言',
  'quickSave.fromYoutube': '來自這部影片',
  'quickSave.fromNetflix': '來自本劇集',
  'quickSave.pairLabel': '卡片語言',
  'quickSave.energyHint': '生成消耗 {{energy}} 能量 · 餘額 {{balance}}',
  'quickSave.errorBalance': '能量不足,無法生成這張卡。',
  'quickSave.errorNetwork': '生成失敗,請再試一次。',
  'quickSave.topUp': '儲值',
  'card.fromSource': '來自你的文件',
  'card.grammar': '文法',
  'card.prosody': '重音與節奏',
  'card.fromClip': '片段',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': '在 Netflix 開啟',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': '你的照片',
  'card.lookedUp': '查詞',
  'card.expand': '展開',
  'card.collapse': '收合',

  // 音訊影片 → 卡片
  'mediaView.title': '把片段變成卡片',
  'mediaView.subtitle': '上傳英文音訊或影片,我們轉寫,你來挑。',
  'mediaView.chooseFile': '拖入檔案或點此選擇',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': '最長 90 分鐘 · 最大 100MB',
  'mediaView.guideExtension.body': '已裝擴充功能?在 YouTube/Netflix 影片頁上選取字幕裡的字,點 Piccard 按鈕即可存卡;也可以在下方匯入你自己的影片/音訊檔 →',
  'mediaView.guideExtension.dismiss': '關閉',
  'mediaView.uploading': '上傳中…',
  'mediaView.transcribe': '轉寫',
  'mediaView.transcribing': '轉寫中…',
  'mediaView.transcribeHint': '短影片幾秒就好。',
  'mediaView.changeFile': '換一個檔案',
  'mediaView.costN': '{{energy}} 能量',
  'mediaView.phrases': '{{count}} 個片語',
  'mediaView.make': '生成 {{count}} 張卡片',
  'mediaView.uncertain': '這句建議核對',
  'mediaView.preview': '播放這句',
  'mediaView.success': '{{count}} 張卡片已進入複習',
  'mediaView.errorUpload': '上傳失敗,請重試。',
  'mediaView.errorTooLarge': '超過 100MB——先剪短一些。',
  'mediaView.errorSilent': '未偵測到人聲。可能是靜音影片——請選擇有對白的片段。',
  'mediaView.errorFormat': '格式不支援,請用 mp4、mov、webm 或音訊檔。',
  'mediaView.errorTranscribe': '轉寫服務繁忙,請重試——本次未扣費。',
  'mediaView.tooLongDuration': '超過 {{n}} 分鐘——請把片段剪短後再新增。',
  'mediaView.errorContent': '未在此檔案中偵測到英文語音。',
  'mediaView.errLanguageMismatch': '這段音影片聽起來不是{{lang}}。請選擇{{lang}}素材，或先切換學習語言。',
  'mediaView.errBadFormat': '這個檔案的實際格式無法轉寫（例如 .avi/.mkv 改名成 .mp4）。請轉成 mp4、mov、webm 或常見音訊格式。',
  'mediaView.errNoSpeech': '未在此檔案中偵測到語音。請選擇有清晰對話的片段。',
  'mediaView.errDecode': '無法處理該檔案的音訊。請改用標準的 mp4、mov、webm 或音訊檔。',
  'mediaView.fromFile': '來自 {{name}}',
  'mediaView.errorLowEnergy': '能量不足。',
  'mediaView.errorConfirm': '無法根據這些片語生成卡片,請重試。',
  'mediaView.empty': '此片段未找到片語。',
  'mediaView.costEstimate': '約 {{cost}} 能量 · 約 {{min}} 分鐘',
  'mediaView.feeApplied': '（已扣除 {{n}} 能量檢測費）',
  'settings.section.energy': '能量',
  'settings.section.learning': '學習',
  'redeem.title': '兌換碼',
  'redeem.desc': '輸入兌換碼以取得能量。',
  'redeem.placeholder': '輸入兌換碼',
  'redeem.apply': '兌換',
  'redeem.applying': '…',
  'redeem.success': '兌換成功！+{{cents}} 能量',
  'redeem.already': '你已經兌換過此碼。',
  'redeem.invalid': '無效或已過期的兌換碼',
  'redeem.error': '出錯了,請重試。',
  'redeem.balance': '{{balance}} 能量可用',

  // Landing (v11 — extension-first entry, closed loop) — zh-TW. Copy frozen in
  // docs/plans/landing-v11.md; keywords per docs/plans/seo-research/zh-TW-keywords.md.
  'landing.hero.title': '看 YouTube\n學英文單字',
  'landing.hero.subtitle': '在你平常看的英語影片上開啟中英對照字幕。點一下字幕行,再點一下做單字卡,現成的單字卡就送回來 — 每張都有釋義、例句、發音,並在你快忘記時再次出現。',
  'landing.hero.cta': '免費開始',
  'landing.hero.ctaNote': '免費,不用綁卡。',
  'landing.hero.ctaExtension': '加到 Chrome',
  'landing.hero.videoCaption': '從雙語字幕面板到 Piccard——一行字幕,變成數張候選單字卡。',
  'landing.how.title': '點擊字幕查單字',
  'landing.how.subtitle': '你看什麼,就複習什麼——循環自動完成。',
  'landing.how.step1Title': '開啟雙語字幕看影片',
  'landing.how.step1Desc': 'Chrome 擴充功能讓你正在看的影片顯示中英對照字幕——每一行都同步到秒。',
  'landing.how.step2Title': '點一行字幕,留下卡片',
  'landing.how.step2Desc': '點一下字幕行,它就進到 Piccard,再點一下做好單字卡——每張都有釋義、例句、發音。想要的留下,不想要的丟掉。',
  'landing.how.step3Title': '該複習時,它們自己回來',
  'landing.how.step3Desc': 'FSRS 間隔重複替每張卡片排程,在你快忘記之前讓它回來——而且每張卡都能重播它當初出現在 YouTube 上的那一刻。',
  'landing.how.otherTitle': '其他做卡方式',
  'landing.how.other3': '在網頁上點兩下單字——離線釋義立刻出現,再點一下,Piccard 就把卡片做好。',
  'landing.how.ownLink': '已經有字表了?直接帶來 →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': '已有的字表,直接變卡',
  'landing.bring.subtitle': '影片只是入口之一。你真正需要的單字,大多已經躺在某處 — 教科書的一章、考試字表、上課錄音。貼上或上傳,Piccard 提議卡片,你只留下值得學的。',
  'landing.bring.pasteTitle': '貼上文字',
  'landing.bring.pasteDesc': '教科書一頁、一篇文章、手邊現成的字表。貼上來,候選卡片就會回來 — 可以全選,也可以只留值得學的。每次確認最多 20 張。',
  'landing.bring.pdfTitle': '拖入 PDF',
  'landing.bring.pdfDesc': '課程資料、考試字表、閱讀講義 — PDF 走同一條提議流程。卡片排開,勾選,一次確認。',
  'landing.bring.fileTitle': '上傳音訊/影片',
  'landing.bring.fileDesc': '英語授課或 podcast 錄音(最長 90 分鐘)會被轉寫,每句附 0–100 的值得學分數(計入你的學習目標),值得留的預先勾好。可上傳的是你所學語言的音訊(學英語即英語授課)。',
  'landing.bring.cta': '開啟應用程式',
  'landing.bring.ctaNote': '免費開始,無需信用卡。',
  'landing.pricing.title': '用多少,付多少',
  'landing.pricing.subtitle': '註冊送能量,隨時儲值,永不過期。',
  'landing.pricing.starter': '入門版',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': '起',
  'landing.pricing.starterGrant': '註冊送 150 能量',
  'landing.pricing.starterSwitch': '語言隨時切換',
  'landing.pricing.starterSrs': '完整的間隔重複複習',
  'landing.pricing.starterDevices': '任何裝置都能用',
  'landing.pricing.starterSync': '含雲端同步',
  'landing.pricing.starterCta': '開始使用',
  'landing.pricing.topup': '儲值方案',
  'landing.pricing.topupRate': '1 能量 ≈ 1 張文字卡',
  'landing.pricing.starterAiImage': '含文字卡;AI 圖片卡是付費功能',
  'landing.pricing.topupCards': '$5 = 500 張卡',
  'landing.blog.backHome': '← 返回首頁',
  'landing.welcome.openApp': '開啟 Piccard',
  'landing.faq.heading': '常見問題',
  'landing.faq.q1': '真的是免費嗎?',
  'landing.faq.a1': '真的!每個新帳號都送 150 免費能量,夠做好幾部影片、幾份 PDF,或約 150 張卡片。想要更多時,再用能量包儲值($5/$10/$20)。能量永不過期。',
  'landing.faq.q2': '和 Language Reactor、Anki 有什麼不同?',
  'landing.faq.a2': '兩個都是好工具,但中間有個斷層:Language Reactor 只管顯示字幕,存單字得匯出再匯入 Anki;而 Anki 本身要花功夫設定,每張卡都得自己動手做。Piccard 補上這個斷層。點一下字幕行,釋義、例句、發音都齊的完整卡片已經做好——想要的留下,不想要的丟掉,複習排程交給 FSRS-6(Anki 也採用的最新演算法)。匯入較長的影片時,每個片語都會得到 0–100 的值得學分數,懸停可看一行理由,學習目標也計入其中——哪個詞值得花時間,不用再猜。不用設定,不用匯出匯入。',
  'landing.faq.q3': '會讓 YouTube 變慢或破壞字幕嗎?',
  'landing.faq.a3': '不會。擴充功能很輕量 — 它會在影片上方加上自己的字幕面板,不會去改 YouTube 本身。哪天不想要了,一次點擊全部移除。不需要帳號也能用。',
  'landing.faq.q5': '什麼是間隔重複?',
  'landing.faq.a5': '一種排程演算法,決定每張卡什麼時候回來 — 剛學還新鮮時來得勤,沉澱進長期記憶後越來越疏。Piccard 採用 Anki 也使用的最新 FSRS-6 演算法,而你的卡片來自你看過、讀過的內容。',
  'landing.faq.q7': '支援哪些語言?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 優先 — Piccard 專為學英語的韓語、繁體中文和日語使用者打造。西班牙語、法語、德語也可使用,隨時切換。',

  'landing.faq.q8': '我已經有一份字表,Piccard 能把它變成卡嗎?',
  'landing.faq.a8': '能 — 這是最快的入口。貼上文字或拖入 PDF,Piccard 就會提議卡片(每次最多 20 張):釋義、例句、發音俱全。上課錄音也行 — 上傳音訊會被轉寫,每句附 0–100 的值得學分數。',
  'landing.faq.q9': 'Netflix 上能用嗎？',
  'landing.faq.a9': '可以，有文字字幕的劇集都支援。若片源同時提供兩種語言的字幕，影片上還能顯示雙語字幕（英語＋你的母語）。開著面板觀看，點一句台詞即生成卡片，卡片能按精確到秒的時間點跳回 Netflix。少數片源是圖片字幕、無法讀取；受 DRM 限制也不能截圖或保存原聲——留下的是單字和那個瞬間。',
  'landing.faq.still': '還有疑問?寄信到',
  'landing.footer.tagline': '把你看的影片變成單字卡',
  'landing.footer.blog': '部落格',
  'landing.footer.privacy': '隱私',
  'landing.footer.terms': '條款',
  'landing.footer.contact': '聯絡我們',
  'landing.footer.rights': '保留所有權利。',
  'landing.finalCta.title': '你的第一張卡片,只差一個 YouTube 影片',
  'landing.finalCta.subtitle': '看部影片,點一行字幕,做好卡片——它會在你忘記之前回來。',
  'landing.finalCta.cta': '免費開始',
  'landing.finalCta.ctaExtension': '加到 Chrome',
  'landing.finalCta.note': '無需綁卡。內含 150 能量。',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'YouTube 雙語字幕與單字卡 — 看 YouTube 學英文 | Piccard',
  'seo.description': '在 YouTube 開啟中英對照字幕,點一下字幕行,值得學的單字就變成現成單字卡送回來;FSRS 間隔重複會在你快忘記時帶它們回來。免費開始。',
}
